var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExameLaboratorial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 1h40v40H1z"
  })), /*#__PURE__*/React.createElement("style", null, ".d-laboratorial{fill:#454f63}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)",
    style: {
      isolation: "isolate"
    },
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.631 14.219a10.96 10.96 0 1010.96 10.96 10.96 10.96 0 00-10.96-10.96z",
    fill: "#c5fad9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d-laboratorial",
    d: "M22.525 13.191a5.633 5.633 0 00-3.057.9V9.21h.8a.546.546 0 00.546-.546V5.742a.546.546 0 00-.541-.546H9.903a.546.546 0 00-.542.546v2.922a.546.546 0 00.546.546h.8v19.618a4.38 4.38 0 008.76 0v-5.2a5.666 5.666 0 103.058-10.437zm-10.725.221h6.575v1.249H11.8zm-1.351-7.124h9.277v1.83h-9.277zm7.926 2.922v3.11H11.8V9.21zm0 19.618a3.288 3.288 0 01-6.575 0v-1.661h2.969a.546.546 0 00.546-.546v-1.416a.546.546 0 10-1.092 0v.87H11.8v-7.608h2.422v1.8a.546.546 0 101.092 0v-2.346a.546.546 0 00-.546-.546H11.8v-1.622h5.986a5.656 5.656 0 00.589 6.959v6.117zm4.149-5.4a4.574 4.574 0 114.574-4.574 4.579 4.579 0 01-4.573 4.577z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M23.078 15.979a.463.463 0 00-.637 0c-.2.187-1.934 1.874-1.934 3.405a2.252 2.252 0 104.5 0c.005-1.526-1.731-3.217-1.929-3.405zm-.319 4.731a1.328 1.328 0 01-1.326-1.327 4.553 4.553 0 011.326-2.405 4.566 4.566 0 011.327 2.405 1.328 1.328 0 01-1.327 1.327zM15.159 22.567a.463.463 0 10-.171.562.468.468 0 00.171-.562z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExameLaboratorial);
export default __webpack_public_path__ + "static/media/exame-laboratorial.4cbf4a19.svg";
export { ForwardRef as ReactComponent };